import { guid } from "../../helpers/string-util.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import ItemPicker from "../ItemPicker/ItemPicker.js";

/**
 * Standalone (not to be used within a form) radio button group widget.
 *
 * @param {object[]} elements - Elements to be mapped to radio buttons.
 *   Each element should have a `label` property with a renderable, and can
 *   have any `value` property
 */
export default class RadioGroupWidget extends Widget {
	constructor({ elements = [] }) {
		super(...arguments);

		this._name = guid();

		this._itemPicker = new ItemPicker({
			liveSearch: false,
			items: elements,
			itemRenderer: this._radioButtonRenderer.bind(this),
		});

		this.selectionChanged = this._itemPicker.selectionChanged;
	}

	getElements(...rest) {
		return this._itemPicker.getItems(...rest);
	}

	getSelected(...rest) {
		return this._itemPicker.getSelected(...rest);
	}

	getValue(...rest) {
		return this._itemPicker.getValue(...rest);
	}

	select(...rest) {
		return this._itemPicker.select(...rest);
	}

	selectValue(...rest) {
		return this._itemPicker.selectValue(...rest);
	}

	isSelected(...rest) {
		return this._itemPicker.isSelected(...rest);
	}

	renderContentOn() {
		// empty because all rendering is done in _renderRootOn().
	}

	_renderRootOn(html) {
		html.render(this._itemPicker);

		return html;
	}

	_radioButtonRenderer(element) {
		return (html) => {
			html.div(
				{ klass: "radio" },
				html.label((html) => {
					const input = html.input({
						type: "radio",
						name: this._name,
						"data-test": element.dataTestName,
					});
					if (element.selected) {
						input.attr({ checked: true });
					}
				}, element.label),
			);
		};
	}
}
